// extracted by mini-css-extract-plugin
export var pillWrapper = "_yo-0";
export var showOverflow = "_yo-1";